const OpenCage = {
    apiKey:"f1319c12b8bd48e29794cf5651ab5c60"
}

export default OpenCage;